module.exports = __webpack_public_path__ + "static/media/on-hold-back.7a83ebdb.png";